type ChatReference = { orgThreadId: string; routeId: string };

/** A single explicit call request, fenced against identity and route changes. */
export function createYourImaiVoiceLauncher(dependencies: {
  scope: string;
  getScope: () => string | null;
  hasCall: () => boolean;
  ensureChat: () => Promise<ChatReference>;
  connect: (chat: ChatReference) => void;
}) {
  let pending: Promise<void> | null = null;
  return {
    start(): Promise<void> {
      if (pending) return pending;
      if (
        dependencies.getScope() !== dependencies.scope ||
        dependencies.hasCall()
      )
        return Promise.resolve();
      pending = dependencies
        .ensureChat()
        .then((chat) => {
          if (
            dependencies.getScope() === dependencies.scope &&
            !dependencies.hasCall()
          )
            dependencies.connect(chat);
        })
        .finally(() => {
          pending = null;
        });
      return pending;
    },
  };
}
